import React from 'react';
import { compose, withState } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';
import OkButton from '../atoms/OkButton';

const styles = {};

const enhance = compose(withState('isSendMail', 'setIsSendMail', 1));
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  },
  radioLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginRight: '40px'
  }
});

const Main = enhance(
  ({
    openConfirm,
    updateOpenConfirm,
    okAction,
    message,
    isSmall,
    isSendMail,
    setIsSendMail
  }) => {
    const cancelAction = () => updateOpenConfirm(false);
    const classes = useStyles();
    return (
      <Dialog
        open={openConfirm}
        onEnter={() => {
          setIsSendMail(1);
        }}
        onClose={() => {
          updateOpenConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classes.paperWidthSm
        }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
          <DialogContentText>
            ■お知らせメール送信設定（店舗あて）
          </DialogContentText>
          <RadioGroup
            row
            value={String(isSendMail)}
            onChange={e => {
              setIsSendMail(parseInt(e.target.value, 10));
            }}
          >
            <FormControlLabel
              className={classes.radioLabel}
              value="1"
              control={<Radio color="primary" />}
              label="送信する"
            />
            <FormControlLabel
              className={classes.radioLabel}
              value="0"
              control={<Radio color="primary" />}
              label="送信しない"
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <OkButton onClickAction={() => okAction(isSendMail)} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
